import { configureStore } from "@reduxjs/toolkit";
import myReducerName from "./compareSlice";

export default configureStore({
  reducer: {
    compare: myReducerName,
  },
});
